import { Injectable } from '@angular/core';
import { LoanStatusConstant } from './constants';
import { EmiStatus, EmpStatus, EmployeeDesignation, RelationsData, TenureDetails } from './model';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor() { }


  // variable to store data that only be needed until application is open in the browser and that data needs to be refresh when application reload's
  private cache:any = {
    loanData: null,
    userInfo:null,
    allConstant:null,
    allConstantLanding:null,
    instituteList:null,
    currentInstitute:null,
    products:null,
    cityApiRes:null,
    selectedCatogory:null,
    currentInstituteCourses:null,
    loanId:null,
    product:null,
    productCat:null,
    kycTab:null,
    proofTab:null,
    currentApplicant:null,
    panNumber:null,
    emailVerified:false,
    insuranceList:null,
    userLogin:false,
    ishome:false, 
    lat:null,
    lng:null,
    panData: null,
    selectedTenure:null,
    stats:null,
    pincode: null
  };

  get getCurrentApplicant(){
    return this.loanDetails?.loanApplicantDetails?.find((applicant:any)=> applicant.id === this.getCache('currentApplicant'));
  }

  get loanDetails(){

    const loan = this.cache.loanData;

    if(!loan){
      return null;
    }
   
    return {...loan,
      isInRejectedState: loan.statusId == LoanStatusConstant.rejected,
      inSanctionedState: loan.statusId == LoanStatusConstant.sanctioned && loan.amount == null,
      isActive: loan.statusId == LoanStatusConstant.active,
      isSFLoan: loan.productCategory == 'EL_SF',
      isCFLoan: loan.productCategory == 'EL_CF',
      isSDLoan: loan.productCategory == 'EL_SDC',
      isOCLoan: loan.productCategory == 'EL_OC',
      studentNotAdded: loan.institutionInfo != null && loan.institutionInfo!.candidateName == null,
      loanDetailsNotAdded: loan.institutionInfo != null && loan.institutionInfo!.tenorMonths == null,
      isMaAadharNotComplete:
      loan.loanApplicantDetails && (loan.loanApplicantDetails[0].aadhaarConfirmation != true),
      isMaSelfiNotComplete: loan.loanApplicantDetails[0].loanAttachment.find((element:any) => element.docType == 'SELFIE') == null,
      isAdditionalInfoNotAdded: loan.institutionInfo!.coachingCenterId != null && loan.institutionInfo!.dob == null,
      isCourceNotSelected : loan.institutionInfo == null,
      notSubmitedForReview: loan.reviewedAndSubmitted != true,
      isMaPanNotComplete: loan.loanApplicantDetails && (loan.loanApplicantDetails[0].panConfirmation != true),
      isEmployed : loan.institutionInfo!.employmentStatus == '1',
      isSelfEmployed : loan.institutionInfo!.employmentStatus == '2',
      hasMoratorium : loan.institutionInfo?.processType == '1',
      isCapacitaFlow : loan.institutionInfo?.processType == '3',
      empDetailsNotAdded: loan.empInfo == null,
      isMaBankNotComplete: loan.loanApplicantDetails[0].bankConfirmation !== true,
      isPanInfoNotSaved: loan.loanApplicantDetails && (loan.loanApplicantDetails[0].panInfo == null),
      isPfNotComplete : loan.processingFee == null,
      hasCoapplicant : loan.loanApplicantDetails?.length > 1,
      applicantList : loan.loanApplicantDetails.filter((element:any) => element.id !== '1'),
      

    
    };

  };

  get empStatus():EmpStatus[]{
    return this.getDataFromContantAll('employment_status')?.sort((a:EmpStatus,b:EmpStatus)=> parseInt(a.id) - parseInt(b.id));
  }

  get employeeDesignation():EmployeeDesignation[]{
    return this.getDataFromContantAll('employee_designation')?.sort((a:EmpStatus,b:EmpStatus)=> parseInt(a.id) - parseInt(b.id))
  }

  get relations():RelationsData[]{
    return this.getDataFromContantAll('relation');
  }

  get waitingResponse(){
    return this.getDataFromContantAll('waiting_response');
  }
  get config(){
    return this.getDataFromContantAll('config');
  }

  get customerTestimonials(){
    return this.getDataFromContantAll('customer_testimonial');
  }

  get rmDetails(){
    return this.getDataFromContantAll('rm_details');
  }





 /**
  * method used to access the value of the cache variable by passing the key as target.
  * @param target : string - will be the key of the cache object.
  * @returns value of the respective key of the cache object.
  */
  getCache(target:string){
    if(this.cache.hasOwnProperty(target)){
      return this.cache[target];
    }else{
      console.error('No key found with '+target+' name');
    }

  }
 /**
  * method used to clear the values of the cache variable.
  */
  clearCache(){
    Object.keys(this.cache).forEach((key:string)=>{
        this.cache[key] = null;
    });

  }

  /**
  * method used to set the value of the cache variable by passing the key as target.
  * @param target : string - will be the key of the cache object.
  * @param value : type can be anything - value that you want to set a
  * @returns value of the respective key of the cache object.
  */
  setCache(target:string, value:any){
    if(this.cache.hasOwnProperty(target)){
      this.cache[target] =value;
      return this.cache[target];
    }else{
      console.error('No key found with '+target+' name');
    }

  }


  /**
   * Method to get the data from the contant/all api reponse object by passing the key
   * @param key - string -  key for which you want the value
   * @returns value of the passed key
   */
  getDataFromContantAll(key:string){
    let data = this.getCache('allConstant')?.find((data:any)=> data.key === key)?.value;
    if(!data)
     data = this.getCache('allConstantLanding')?.find((data:any)=> data.key === key)?.value;
    return data;
  }

 
  getTenureDetails():TenureDetails[]{
    const loanCommercialDetails = this.loanDetails.loanCommercialDetails;
    const e:TenureDetails[] = [];
      for (var i = 0; i < loanCommercialDetails.length; i++) {
        e.push({
          index: i,
          emi: loanCommercialDetails[i].emi,
          customerRoi: loanCommercialDetails[i].customerRoi ?? 0.0,
          emiStatus: EmiStatus.loaded,
          selectedTenor: {
            emiType:this.loanDetails.institutionInfo?.emiType ?? 'NA',
            institutionId: this.loanDetails.institutionInfo?.coachingCenterId,
            interestRate: 0,
            refInstitutionId: '0',
            subvention: 0,
            courseId:this.loanDetails.institutionInfo?.coachingCenterCourseId,
            tenor: loanCommercialDetails[i].tenor,
            customerRoi: 0,
          },
          amount: loanCommercialDetails[i].amount,
          emiBeforeMoratorium: loanCommercialDetails[i].emiBeforeMoratorium,
        });
      }
      return e;
  }


}
